<template>
  <div class="order-form-container p-4 bg-light">
    <div v-if="!hideHeader" class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0 text-dark fw-semibold">
            {{ isEditMode ? 'Order Detail' : 'Order Create' }}
        </h3>
      <div>
        <button class="btn btn-outline-secondary me-2" @click="$emit('cancel')">Hủy bỏ</button>
        <button class="btn btn-primary px-4" @click="handleSubmit" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
          {{ isEditMode ? 'CẬP NHẬT' : 'XÁC NHẬN' }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-header bg-white fw-bold">Thông tin chung</div>
          <div class="card-body row">
            <div class="col-md-6 mb-3">


              <label class="form-label small fw-bold">Dịch vụ *</label>
              <select
                v-model="formData.service_id"
                class="form-select"
                :disabled="isFieldDisabled('service') || loadingServices"
                required
              >
                <option value="">{{ loadingServices ? 'Đang tải...' : 'Chọn dịch vụ' }}</option>

                <option
                  v-for="item in services"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Tên hoá đơn *</label>
              <input v-model="formData.name" type="text" class="form-control" placeholder="Nhập tên hóa đơn">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Giá trị đơn hàng (USD) *</label>
              <input v-model.number="formData.price" type="number" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Ghi chú</label>
              <input v-model="formData.note" type="text" class="form-control" placeholder="Nhập tên hóa đơn">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Ghi chú khách hàng</label>
              <input v-model="formData.customer_note" type="text" class="form-control" placeholder="Nhập tên hóa đơn">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Địa chị trả hàng</label>
              <input v-model="formData.return_address" type="text" class="form-control" placeholder="Nhập tên hóa đơn">
            </div>
            <div class="col-md-6 mb-3 d-flex align-items-center">
              <div class="form-check form-switch mt-3">
                <input v-model="formData.is_insurance" class="form-check-input" type="checkbox" id="is_insurance">
                <label class="form-check-label small fw-bold ms-2" for="is_insurance">Bảo hiểm hàng hoá</label>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-header bg-white fw-bold">Địa chỉ người nhận</div>
          <div class="card-body row">
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Tên người nhận *</label>
              <input v-model="formData.receiver_name" class="form-control" required>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Số điện thoại</label>
              <input v-model="formData.receiver_phone" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold">Email</label>
                <input
                    v-model="formData.receiver_email"
                    class="form-control"
                >
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">IOSS Number</label>
              <input class="form-control">
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label small fw-bold">Địa chỉ nhận hàng *</label>
              <textarea v-model="formData.receiver_address" class="form-control" rows="2"></textarea>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label small fw-bold">Thành phố *</label>
              <input v-model="formData.receiver_city" class="form-control">
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label small fw-bold">Bang *</label>
              <input v-model="formData.receiver_state" class="form-control">
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label small fw-bold">Quốc gia *</label>
              <multiselect
                v-model="selectedCountry"
                :options="countries"
                label="display_name"
                track-by="id"
                placeholder="Chọn quốc gia..."
                :loading="loadingCountries"
                :disabled="loadingCountries"
                select-label=""
                deselect-label=""
                selected-label="Đã chọn"
              >
                <template #noResult>
                  <span class="small">Không tìm thấy quốc gia</span>
                </template>
              </multiselect>
            </div>
            <div class="col-md-6">
              <label class="form-label small fw-bold">Post Code *</label>
              <input v-model="formData.receiver_post_code" class="form-control" required>
            </div>
            <div class="col-md-6">
              <label class="form-label small fw-bold">Ghi chú người nhận</label>
              <input v-model="formData.receiver_note" class="form-control">
            </div>
            <div class="col-md-6">
              <label class="form-label small fw-bold">Ioss Number</label>
              <input v-model="formData.ioss_number" class="form-control">
            </div>
          </div>
        </div>

        <section class="card mb-4 border-0 shadow-sm order-items-section" aria-labelledby="order-items-title">
          <div class="card-header bg-white d-flex justify-content-between align-items-center gap-3 order-items-header">
            <div>
              <h5 id="order-items-title" class="h6 mb-1 fw-bold">Chi tiết hàng hoá</h5>
              <p class="small text-muted mb-0">Khai báo từng mặt hàng trong đơn.</p>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="badge rounded-pill bg-light text-dark border">{{ formData.order_items.length }} mặt hàng</span>
              <button type="button" class="btn btn-outline-primary add-item-button" @click="addItem">
                <i class="bi bi-plus-lg me-2" aria-hidden="true"></i>Thêm mặt hàng
              </button>
            </div>
          </div>

          <div class="card-body p-3 p-md-4">
            <article
              v-for="(item, index) in formData.order_items"
              :key="index"
              class="order-item-card"
            >
              <div class="d-flex justify-content-between align-items-center gap-3 mb-4">
                <div class="d-flex align-items-center gap-3 min-w-0">
                  <span class="order-item-index" aria-hidden="true">{{ index + 1 }}</span>
                  <div class="min-w-0">
                    <h6 class="order-item-title">Mặt hàng {{ index + 1 }}</h6>
                    <p class="small text-muted mb-0">Thông tin sản phẩm và khai báo hải quan</p>
                  </div>
                </div>
                <button
                  v-if="formData.order_items.length > 1"
                  type="button"
                  class="btn btn-outline-danger order-item-remove"
                  :aria-label="`Xóa mặt hàng ${index + 1}`"
                  @click="removeItem(index)"
                >
                  <i class="bi bi-trash3 me-sm-2" aria-hidden="true"></i>
                  <span class="d-none d-sm-inline">Xóa</span>
                </button>
              </div>

              <div class="row g-3">
                <div class="col-lg-6">
                  <label class="form-label fw-semibold" :for="`order-item-name-${index}`">Tên mặt hàng <span class="text-danger">*</span></label>
                  <input
                    :id="`order-item-name-${index}`"
                    v-model="item.name"
                    class="form-control"
                    placeholder="Ví dụ: Áo thun cotton"
                    required
                  >
                </div>
                <div class="col-lg-6">
                  <label class="form-label fw-semibold" :for="`order-item-description-${index}`">Mô tả hàng hoá</label>
                  <input
                    :id="`order-item-description-${index}`"
                    v-model="item.description"
                    class="form-control"
                    placeholder="Màu sắc, kích cỡ..."
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-hscode-${index}`">HSCode</label>
                  <input
                    :id="`order-item-hscode-${index}`"
                    v-model="item.hscode"
                    class="form-control"
                    placeholder="Mã HS"
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-quantity-${index}`">Số lượng</label>
                  <input
                    :id="`order-item-quantity-${index}`"
                    v-model.number="item.quantity"
                    type="number"
                    min="1"
                    class="form-control"
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-price-${index}`">Giá trị (USD)</label>
                  <input
                    :id="`order-item-price-${index}`"
                    v-model.number="item.price"
                    type="number"
                    min="0"
                    step="0.01"
                    class="form-control"
                    placeholder="0.00"
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-mp-id-${index}`">
                    MPId <span class="text-muted fw-normal">(không bắt buộc)</span>
                  </label>
                  <input
                    :id="`order-item-mp-id-${index}`"
                    v-model="item.mp_id"
                    type="text"
                    maxlength="2350"
                    class="form-control"
                    placeholder="Nhập MPId"
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-nsp-id-${index}`">
                    NSPId <span class="text-muted fw-normal">(không bắt buộc)</span>
                  </label>
                  <input
                    :id="`order-item-nsp-id-${index}`"
                    v-model="item.nsp_id"
                    type="text"
                    maxlength="2350"
                    class="form-control"
                    placeholder="Nhập NSPId"
                  >
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold" :for="`order-item-sp-id-${index}`">
                    SPId <span class="text-muted fw-normal">(không bắt buộc)</span>
                  </label>
                  <input
                    :id="`order-item-sp-id-${index}`"
                    v-model="item.sp_id"
                    type="text"
                    maxlength="2350"
                    class="form-control"
                    placeholder="Nhập SPId"
                  >
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>

      <div class="col-lg-4">
        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-header bg-white fw-bold">Thông tin kiện hàng</div>
          <div class="card-body row">
            <div class="col-12 mb-3">
              <label class="form-label small fw-bold">Tên kiện hàng *</label>
              <input v-model="formData.package_name" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Dài (cm) *</label>
              <input v-model.number="formData.length" type="number" step="0.00001" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Rộng (cm) *</label>
              <input v-model.number="formData.width" type="number" step="0.00001" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Cao (cm) *</label>
              <input v-model.number="formData.height" type="number" step="0.00001" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label small fw-bold">Cân nặng (g) *</label>
              <input v-model.number="formData.weight" type="number" class="form-control">
            </div>
            <div class="col-12 mb-3">
              <label class="form-label small fw-bold text-primary">Dimensions</label>
              <div class="form-control bg-light fw-bold text-primary border-primary border-opacity-25">{{ dimensionsDisplay }}</div>
            </div>
            <div class="col-12 mb-3 border-top pt-3">
              <label class="form-label small fw-bold">Mã vận đơn gửi đến</label>
              <input
                :value="isTrackingHiddenForCustomer ? 'Thanh toán để xem' : formData.tracking_number"
                @input="formData.tracking_number = $event.target.value"
                class="form-control"
                :disabled="isFieldDisabled('tracking_number') || isTrackingHiddenForCustomer"
                :class="{ 'is-locked': isFieldDisabled('tracking_number') || isTrackingHiddenForCustomer, 'text-danger fw-bold': isTrackingHiddenForCustomer }"
              >
              <small v-if="isFieldDisabled('tracking_number')" class="text-muted">
                <i class="fa fa-lock me-1"></i>Chỉ admin mới có thể chỉnh sửa mã vận đơn
              </small>
            </div>
            <div class="col-12 mb-3">
              <label class="form-label small fw-bold">Link Label</label>
              <input
                v-model="formData.label_url"
                class="form-control"
                placeholder="https://..."
                :disabled="isFieldDisabled('label_url')"
                :class="{ 'is-locked': isFieldDisabled('label_url') }"
              >
              <small v-if="isFieldDisabled('label_url')" class="text-muted">
                <i class="fa fa-lock me-1"></i>Chỉ admin mới có thể chỉnh sửa link label
              </small>
              <small v-else-if="formData.label_url">
                <a :href="formData.label_url" target="_blank" class="text-primary">
                  <i class="fa fa-external-link me-1"></i>Mở link
                </a>
              </small>
            </div>
            <div class="col-12 mb-3">
              <label class="form-label small fw-bold">Kho nhận hàng</label>
              <input v-model="formData.warehouse_id" class="form-control">
            </div>
          </div>
        </div>

        <div class="card border-0 shadow-sm bg-primary text-white">
          <div class="card-body">
            <h6 class="fw-bold mb-3">Ước tính phí</h6>
            
            <div v-if="calcError" class="alert alert-danger py-2 px-3 small border-0 mb-3 shadow-sm" style="background: #ff4d4d; color: white; font-weight: bold;">
              <i class="fa fa-exclamation-triangle me-1"></i> {{ calcError }}
            </div>

            <template v-if="estimatedFees.detail && estimatedFees.detail.length > 0">
              <div v-for="(fee, index) in estimatedFees.detail" :key="index" class="d-flex justify-content-between mb-2 small">
                <span>{{ fee.name }}:</span>
                <span>{{ Number(fee.amount || 0).toLocaleString() }} {{ (estimatedFees.currency || 'vnd').toUpperCase() }}</span>
              </div>
            </template>
            <div v-else class="d-flex justify-content-between mb-2 small">
              <span>Cước vận chuyển:</span>
              <span>0 đ</span>
            </div>
            <div class="d-flex justify-content-between fw-bold border-top pt-2 mt-2">
              <span>Tổng cộng:</span>
              <span>{{ Number(estimatedFees.total || 0).toLocaleString() }} {{ (estimatedFees.currency || 'vnd').toUpperCase() }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useOrders } from "../../composables/useOrders";
import { createToaster } from "@meforma/vue-toaster";
import { useService } from "@/composables/useService";
import { useCountry } from "@/composables/useCountry";
import { useCurrentUser } from "@/composables/useCurrentUser";
import { useUser } from "@/composables/useUser";
import { canViewTrackingBeforePayment } from "@/constants/trackingVisibility";
import { computed } from 'vue';

const { getServicesApi } = useService();
const { getCountriesApi } = useCountry();
const { currentUser, loadCurrentUser } = useCurrentUser();
const { getUsersApi } = useUser();

const dimensionsDisplay = computed(() => {
  const l = formData.length || 0;
  const w = formData.width || 0;
  const h = formData.height || 0;
  const volumeWeight = (l * w * h) / 5000;
  return `${volumeWeight.toLocaleString(undefined, { minimumFractionDigits: 5, maximumFractionDigits: 5 })} `;
});

const selectedCountry = computed({
  get: () => countries.value.find(c => Number(c.id) === Number(formData.receiver_country_id)) || null,
  set: (val) => {
    formData.receiver_country_id = val ? val.id : '';
  }
});

const toaster = createToaster({
  position: "top-right",
  duration: 2000,
});
const props = defineProps({
  orderId: { type: [Number, String], default: null },
  hideHeader: { type: Boolean, default: false },
});

const emit = defineEmits(['save-success', 'cancel']);
const router = useRouter();
const { createOrderApi, getOrderDetailApi, updateOrderApi, calcShippingFeesApi } = useOrders();

const loading = ref(false);
const isEditMode = ref(false);
const services = ref([]);
const countries = ref([]);
const loadingServices = ref(false);
const loadingCountries = ref(false);
const estimatedFees = reactive({ total: 0, currency: 'vnd', detail: [] });
const calcError = ref('');


const formData = reactive({
    service_id: 1, name: '', price: 0,
    receiver_name: '', receiver_phone: '', receiver_address: '', receiver_email: '',
    receiver_city: '', receiver_state: '', receiver_country_id: 1, receiver_note: '', receiver_post_code: '', customer_note: '', note: '', return_address: '',
    package_name: '', length: 0, width: 0, height: 0, weight: 0, tracking_number: '', label_url: '', warehouse_id: '', ioss_number: '',
    customer_id: null,
    is_insurance: false,
    order_items: [{ name: '', hscode: '', mp_id: '', nsp_id: '', sp_id: '', price: 0, quantity: 1, description: '' }]
});




const addItem = () => formData.order_items.push({ name: '', hscode: '', mp_id: '', nsp_id: '', sp_id: '', price: 0, quantity: 1, description: '' });
const removeItem = (index) => {
  if (formData.order_items.length > 1) formData.order_items.splice(index, 1);
};

const handleSubmit = async () => {
  if (!formData.service_id || !formData.receiver_name) {
    alert("Vui lòng điền đủ các trường bắt buộc (*)");
    return;
  }

  loading.value = true;
  let res;

  if (isEditMode.value) {
    res = await updateOrderApi(props.orderId, { ...formData });
  } else {
    res = await createOrderApi({ ...formData });
  }

  // 2. Xử lý kết quả trả về
  if (res.success) {
    toaster.success(isEditMode.value ? 'Cập nhật thành công!' : 'Tạo mới thành công!');
    emit('save-success');
    // Tạo mới từ màn Add xong thì chuyển về danh sách để xem đơn; edit qua modal thì giữ nguyên
    if (!isEditMode.value) {
      router.push({ name: 'indexOrder' });
    }
  } else {
    let errorMsg = res.error || 'Lỗi hệ thống';
    if (res.errors) {
        // Gom tất cả các message lỗi từ object validation
        errorMsg = Object.values(res.errors).flat().join('\n');
    }
    toaster.error("Có lỗi xảy ra: " + errorMsg, { duration: 5000 });
  }

  loading.value = false;
};
const fetchServicesForSelect = async () => {
  loadingServices.value = true;
  try {
    const res = await getServicesApi({ limit: -1, page: 1 });
    if (res.success && res.data) {
      services.value = res.data.data;
    }
  } catch (err) {
    console.error("Lỗi lấy danh sách dịch vụ:", err);
  } finally {
    loadingServices.value = false;
  }
};

const fetchCountriesForSelect = async () => {
    loadingCountries.value = true;
    try {
        const res = await getCountriesApi({ limit: -1, page: 1 });
        if (res.success && res.data) {
            countries.value = res.data.data;
        }
    } catch (err) {
        console.error("Lỗi lấy danh sách quốc gia:", err);
    } finally {
        loadingCountries.value = false;
    }
};



const fetchOrderDetail = async (id) => {
    loading.value = true;
    isEditMode.value = true;
    try {
        const res = await getOrderDetailApi(id);
        if (res.success && res.data) {
            const detailData = res.data.data || res.data;
            Object.assign(formData, detailData);
        } else {
            toaster.error(res.error || "Không thể tải thông tin đơn hàng");
        }
    } catch (err) {
        console.error("Error fetching order:", err);
        toaster.error("Có lỗi xảy ra khi kết nối máy chủ");
    } finally {
        loading.value = false;
    }
};

let calcTimeout = null;
const handleCalcFees = () => {
    if (calcTimeout) clearTimeout(calcTimeout);
    
    calcTimeout = setTimeout(async () => {
        // Collect required fields for calculation
        const payload = {
            order_id: isEditMode.value ? props.orderId : null,
            customer_id: formData.customer_id,
            service_id: formData.service_id,
            country: formData.receiver_country_id,
            weight: formData.weight,
            length: formData.length,
            width: formData.width,
            height: formData.height,
            is_insurance: formData.is_insurance,
            price: formData.price,
            state: formData.receiver_state,
            post_code: formData.receiver_post_code,
            city: formData.receiver_city,
            address: formData.receiver_address,
            order_items: formData.order_items
        };

        const res = await calcShippingFeesApi(payload);
        if (res.success && res.data && !res.data.error) {
            const apiData = res.data.data || {};
            estimatedFees.total = apiData.total || 0;
            estimatedFees.currency = apiData.currency || 'vnd';
            estimatedFees.detail = apiData.detail || [];
            calcError.value = '';
        } else {
            calcError.value = res.data?.message || res.error || "Không thể tính phí";
            estimatedFees.total = 0;
            estimatedFees.detail = [];
        }
    }, 500);
};

// Watch all relevant fields for fee calculation
watch(() => [
    formData.customer_id,
    formData.service_id,
    formData.receiver_country_id,
    formData.weight,
    formData.length,
    formData.width,
    formData.height,
    formData.is_insurance,
    formData.price,
    formData.receiver_state,
    formData.receiver_post_code,
    formData.receiver_city,
    formData.receiver_address,
    formData.order_items.length
], () => {
    handleCalcFees();
}, { deep: true });

onMounted(async () => {
    await loadCurrentUser();
    
    // Nếu là customer thì tự động gán customer_id
    if (!isEditMode.value && currentUser.value) {
        formData.customer_id = currentUser.value.id;
    }

    await Promise.all([
        fetchServicesForSelect(),
        fetchCountriesForSelect()
    ]);


    if (props.orderId) {
        await fetchOrderDetail(props.orderId);
    } else {
        applyCopyPrefill();
    }
});

// Điền sẵn dữ liệu khi người dùng bấm "Copy Order" từ màn chi tiết.
// Chỉ nhận các field có input ở form này, các field khác đã được lược bỏ ở nguồn.
const applyCopyPrefill = () => {
    const raw = sessionStorage.getItem('order_copy_prefill');
    if (!raw) return;
    sessionStorage.removeItem('order_copy_prefill');

    try {
        const prefill = JSON.parse(raw);
        const { order_items, ...rest } = prefill;
        Object.assign(formData, rest);

        if (Array.isArray(order_items) && order_items.length) {
            formData.order_items = order_items.map(it => ({
                name: it.name ?? '',
                hscode: it.hscode ?? '',
                mp_id: it.mp_id ?? '',
                nsp_id: it.nsp_id ?? '',
                sp_id: it.sp_id ?? '',
                price: Number(it.price) || 0,
                quantity: Number(it.quantity) || 1,
                description: it.description ?? ''
            }));
        }

        // customer_id vẫn giữ theo người dùng hiện tại (đã gán ở trên), không copy từ đơn gốc
        toaster.success('Đã sao chép thông tin đơn hàng, kiểm tra lại trước khi tạo!');
    } catch (err) {
        console.error('Lỗi đọc dữ liệu copy order:', err);
    }
};

const isAdmin = computed(() => {
  const role = localStorage.getItem('user_role')?.toLowerCase();
  if (!role) return false;
  const restrictedRoles = ['customer', 'accountant', 'guest'];
  return !restrictedRoles.includes(role) || role === 'admin' || role === 'owner';
});

const isCustomer = computed(() => {
  return localStorage.getItem('user_role')?.toLowerCase() === 'customer';
});

// Các dịch vụ nhập tracking thủ công luôn hiển thị tracking cho khách hàng.
const MANUAL_TRACKING_SERVICE_IDS = [8, 9];
const isTrackingHiddenForCustomer = computed(() => {
  return isCustomer.value
    && formData.remain_fee > 0
    && !MANUAL_TRACKING_SERVICE_IDS.includes(Number(formData.service_id))
    && !canViewTrackingBeforePayment(currentUser.value?.email);
});


// Danh sách các trường cần khóa và điều kiện của chúng
const lockRules = {
  service: () => isEditMode.value && !isAdmin.value,
  price: () => isEditMode.value && formData.status === 'completed',
};

// Hàm dùng chung cho toàn bộ Form
const isFieldDisabled = (fieldName) => {
  if (lockRules[fieldName]) {
    return lockRules[fieldName](); // Chạy hàm kiểm tra điều kiện
  }
  return false; // Mặc định không khóa
};

// Expose để parent component (modal) có thể gọi submit
defineExpose({ handleSubmit });

</script>

<style scoped>
.card { border-radius: 12px; }
.form-control, .form-select { border-radius: 8px; padding: 0.6rem; border: 1px solid #dee2e6; }
.form-control:focus { border-color: #5c61f2; box-shadow: 0 0 0 0.2rem rgba(92, 97, 242, 0.1); }
.card-header { border-bottom: 1px solid #f0f0f0; }
.order-items-header {
  padding: 1rem 1.25rem;
}

.order-item-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 12px;
  background-color: var(--bs-body-bg, #fff);
}

.order-item-card + .order-item-card {
  margin-top: 1rem;
}

.order-item-index {
  display: inline-flex;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: rgba(var(--bs-primary-rgb, 13, 110, 253), 0.1);
  color: var(--bs-primary, #0d6efd);
  font-size: 0.95rem;
  font-weight: 700;
}

.order-item-title {
  margin: 0;
  color: var(--bs-emphasis-color, #212529);
  font-size: 0.95rem;
  font-weight: 700;
}

.min-w-0 {
  min-width: 0;
}

.add-item-button,
.order-item-remove {
  min-height: 44px;
}

.order-item-remove {
  min-width: 44px;
}

@media (max-width: 575.98px) {
  .order-items-header {
    align-items: flex-start !important;
    flex-direction: column;
  }

  .order-items-header > div:last-child {
    width: 100%;
    justify-content: space-between;
  }

  .order-item-card {
    padding: 1rem;
  }

}

.is-locked {
  background-color: #f8f9fa !important;
  pointer-events: none; /* Ngăn mọi hành động click/hover */
  opacity: 0.7;
}

/* Tinh chỉnh Multiselect: Sửa lỗi lệch chữ và khớp với các ô bên cạnh */
:deep(.multiselect) {
  min-height: 41px;
  height: 41px;
  font-size: 13px;
}
:deep(.multiselect__tags) {
  min-height: 41px;
  height: 41px;
  padding: 0 40px 0 12px !important;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  display: flex !important;
  align-items: center !important;
  background: #fff;
}
:deep(.multiselect__single),
:deep(.multiselect__input),
:deep(.multiselect__placeholder) {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 39px !important; /* Trừ đi 2px border */
  background: transparent !important;
  border: none !important;
  font-size: 13px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  vertical-align: top !important;
}
:deep(.multiselect__select) {
  height: 39px;
}
:deep(.multiselect__option) {
  font-size: 13px;
  padding: 10px 12px !important;
  min-height: 38px;
  display: flex;
  align-items: center;
}
</style>
